module.exports = __webpack_public_path__ + "static/divider7-2d14761408d4764178e3ce300f3016b0.svg";